import React, { Component, Fragment } from 'react';
import { css } from "@emotion/core";
import { Elastic, Flex, Mycard, Transition } from "../ui";
import { Btn } from "./../UI-Components/Btn";
import ReactTooltip from "react-tooltip";
import { FooterFactura, Line } from "./index";
import { withRouter } from "react-router";
import { parseJwt, serviceApiResponse } from "../ServiciosMaestros/request";
import { api } from "../ServiciosMaestros/apis";
import Hidden from '@material-ui/core/Hidden';


let aux = 0;
const getTipoMoneda = () => {
    let tipoMoneda = sessionStorage.getItem('configuracion');
    if (tipoMoneda) {
        tipoMoneda = JSON.parse(tipoMoneda)
        tipoMoneda = tipoMoneda.busqueda.find(el => el.campoDb.toLowerCase() == 'total')
        tipoMoneda = tipoMoneda ? tipoMoneda.moneda : 'COP'
    } else {
        tipoMoneda = 'COP'
    }
    return tipoMoneda ? tipoMoneda : 'COP';
}
const Details = ({ inf, i, numeroCampos }) => {
    function tranformValue(value, type, options, db) {
        if (type === "select" || type === "radio") {
            let info = options.filter((op) => {
                return op.value === value
            });
            return info && info.length > 0 ? info[0].name : "";
        } else if (type === "checkbox") {
            let info = "";
            value.map((v, key) => {
                let valueOption = options.filter((op) => {
                    return op.value === v
                });
                return info += `${valueOption[0].name}${key < value.length - 1 ? ", " : ""}`
            });

            return info;
        } else if (type === "date") {
            let date = new Date(value);
            return `${date.getFullYear()}-${(date.getMonth() + 1) < 10 ? "0" : ""}${date.getMonth() + 1}-${date.getDate() < 10 ? "0" : ""}${date.getDate()}`;
        } else if (type === "time") {
            let date = new Date(value);
            return `${date.getHours() > 9 && date.getHours() < 13 ? "" : "0"}${date.getHours() > 12 ? date.getHours() - 12 : date.getHours()}:${date.getMinutes() > 9 ? "" : "0"}${date.getMinutes()} ${date.getHours() > 12 ? "PM" : "AM"}`;
        } else if ((type === "number" && (db === "total" || db == "iva")) || type == 'currency') {
            return `$ ${parseFloat(value).toLocaleString(navigator.language, { minimumFractionDigits: 0 })} ${getTipoMoneda()}`;
        } else if (type === "password") {
            return "********";
        } else {
            return value;
        }

    }

    return (
        <Flex
            jc={"space-between"}
            className={"py-1 "}
            key={`inf-${i}`}
        >
            {
                inf.help && inf.help !== "" &&
                (
                    <ReactTooltip id={`help-${i}`} place="right" type="info" effect="solid">
                        {inf.help}
                    </ReactTooltip>
                )
            }
            <small data-tip data-for={`help-${i}`}><b>{inf.name}</b></small>
            <small className={"mb-0 cg"}>{tranformValue(inf.value, inf.fieldType, inf.fieldOptions, inf.fieldDb)}</small>
            <Line dotted className={"wc"} />
        </Flex>
    )

};


let ruta = {};

class InicioFormulario extends Component {

    constructor(props) {
        super(props);
    }

    state = {
        loading: false,
        infoEmpresa: {},
        detalleFormulario: [],
        loadingDownload: false,
        titulo: "",
        numeroCamposDetalle: 0,
        existeProductos: false,
        productos: [],
    }

    componentDidMount() {
        let titulo = sessionStorage.getItem("titulo");
        let informacionEmpresa = JSON.parse(sessionStorage.getItem("informacion"));
        let detalleFormulario = JSON.parse(sessionStorage.getItem("detalleFormulario"));
        ruta = JSON.parse(sessionStorage.getItem("rutas"));
        let total = 0;
        if (detalleFormulario) {
            detalleFormulario.map((inf) => {
                if (inf.value !== "") total++;
            });
            const prdIndex = detalleFormulario.findIndex(el => el.fieldDb === "productos")
            let existeProductos = false;
            let productos = [];
            if (prdIndex >= 0 && typeof prdIndex == "number") {
                const prd = detalleFormulario.slice()[prdIndex];
                existeProductos = true;
                productos = JSON.parse(prd.value).map(el => {
                    return {
                        name: el.nombre,
                        value: el.count
                    }
                });
                detalleFormulario[prdIndex].value = productos;
                detalleFormulario[prdIndex].fieldDb = "productosFormulario";
                detalleFormulario[prdIndex].entity = "productosFormulario";
            }
            this.setState({
                infoEmpresa: informacionEmpresa,
                detalleFormulario,
                titulo,
                numeroCamposDetalle: total,
                existeProductos,
                productos
            })
        } else {
            this.props.openModal("No existe formularios digelenciados con anterioridad.", "danger");
            this.props.history.push(ruta.home);
        }

    }

    openCheckout(idFactura) {

        let confirmUrl = process.env.REACT_APP_URL_CONFIRMACION;
        let responseUrl = `${window.location.protocol}//${window.location.hostname}${ruta.respuesta}`;

        if (process.env.REACT_APP_SERVER_RESPONSE === "true") {
            responseUrl = `${process.env.REACT_APP_SERVER}${ruta.respuesta}`;
        }

        let descripcionFormulario = this.state.detalleFormulario;
        // let campos=[];
        let descripcion = descripcionFormulario.find(val => val.fieldDb == "descripcion")
        let valor = 0;
        let iva = 0;
        descripcionFormulario.filter((desc) => {
            // campos.push({campoDb:desc.fieldDb,valor:desc.value, entidad:desc.entity});
            if (desc.fieldDb === "total") valor = desc.value;
            if (desc.fieldDb === "iva") iva = desc.value;
        })

        // let iva1=iva!==""?/100:0;
        let total = parseFloat(valor) + parseFloat(iva);
        let subtotal = parseFloat(valor);
        if (descripcion) {
            if (Array.isArray(descripcion.value)) {
                const fieldOptions = descripcion.fieldOptions.filter(el => descripcion.value.includes(el.value)).map(el => el.name);
                descripcion = fieldOptions.join(',')
            } else {
                descripcion = descripcion.value;
            }
        } else {
            descripcion = 'formulario recaudo';
        }
        let data = {
            //Parametros compra (obligatorio)
            name: `formulario recaudo`,
            description: descripcion,
            invoice: String(idFactura),
            currency: getTipoMoneda(),
            amount: String(total),
            tax_base: iva === 0 ? "0" : String(subtotal),
            tax: iva === 0 ? "0" : String(iva),
            country: "co",
            lang: "es",

            //Onpage="false" - Standard="true"
            external: "false",


            //Atributos opcionales
            // extra1: "extra1",
            // extra2: "extra2",
            // extra3: "extra3",
            extra9: "web",
            extra10: String(idFactura),
            confirmation: confirmUrl,
            response: responseUrl,

            //Atributos cliente
            // name_billing: "Andres Perez",
            // address_billing: "Carrera 19 numero 14 91",
            // type_doc_billing: "cc",
            // mobilephone_billing: "3050000000",
            // number_doc_billing: "100000000"
        };
        window.ePayco.checkout.configure({
            key: parseJwt(),
            test: sessionStorage.getItem('test')
        }).open(data);
    }

    crearFactura() {
        this.setState({
            loading: true,
        })
        serviceApiResponse({ formulario: this.state.detalleFormulario }, api.crearFacturaFormulario, "POST")
            .then((response) => {
                if (response.success) {
                    this.setState({
                        loading: false,
                    }, () => this.openCheckout(response.data.id_factura))
                } else {
                    this.setState({
                        loading: false,
                        error: true,
                    })
                }
            })
            .catch((error) => {

            })
    }

    paddingLeft(i) {
        let key = i + aux;
        let pixel = key === 0 || key % 2 === 0 ? 0 : 15;
        return pixel;
    }

    render() {
        return (
            <Elastic
                felx={"1 0 auto"}
                className={"wc cambio "}
                css={css`animation:  ${Transition}  .8s cubic-bezier(0.075, 0.820, 0.165, 1.000) 1;`}
            >
                <Mycard
                    title={`${this.state.titulo}`}
                    back={ruta.home}
                    className={" col-12 col-lg-10 col-xl-7 mx-auto px-0 "}
                    footer={this.state.infoEmpresa.mostrarDatos == 1 && <FooterFactura info={this.state.infoEmpresa} />}
                    history={this.props.history}
                    visible
                >

                    <div className="wc">
                        <div className="col-12 pb-3">
                            <Flex jc={"space-between"}
                                style={{
                                    paddingRight: 15,
                                    paddingLeft: 15,
                                }}
                            >
                                <b className={"cg"}>Resumen de formulario</b>
                                <Line dotted className={"wc"} />
                            </Flex>

                            <div className="row col-12"
                                style={{
                                    marginRight: 0,
                                    marginLeft: 0,
                                }}
                            >
                                {this.state.detalleFormulario.map((inf, key) => {
                                    if (inf.value !== "" && inf.fieldDb !== "productosFormulario") {
                                        return (
                                            <Fragment key={`details-fields-${key}`}>
                                                <Hidden mdUp>
                                                    <div
                                                        className={`${this.state.numeroCamposDetalle > 6 ? "col-12 col-lg-6 col-md-12 col-sm-12 col-xs-12" : "col-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"}`}
                                                        style={{
                                                            paddingRight: 0,
                                                            paddingLeft: 0,
                                                        }}
                                                    >
                                                        <Details
                                                            inf={inf}
                                                            i={key}
                                                        />
                                                    </div>
                                                </Hidden>
                                                <Hidden smDown >
                                                    <div
                                                        className={`${this.state.numeroCamposDetalle > 6 ? "col-12 col-lg-6 col-md-12 col-sm-12 col-xs-12" : "col-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"}`}
                                                        style={{
                                                            paddingRight: 0,
                                                            paddingLeft: this.state.numeroCamposDetalle <= 6 ? 0 : (this.state.numeroCamposDetalle % 2 === 0 ? this.paddingLeft(key) : this.paddingLeft(key) === 15 ? 15 : 0),
                                                        }}
                                                    >
                                                        <Details
                                                            inf={inf}
                                                            i={key}

                                                        />
                                                    </div>
                                                </Hidden>
                                            </Fragment>
                                        )
                                    } else {
                                        aux++;
                                        return "";
                                    }

                                })
                                }
                            </div>
                        </div>
                        {this.state.existeProductos && <div className="col-12 pb-3">
                            <Flex jc={"space-between"}
                                style={{
                                    paddingRight: 15,
                                    paddingLeft: 15,
                                }}
                            >
                                <b className={"cg"}>Resumen de productos</b>
                                <b className={"cg"}>Cantidad</b>
                                <Line dotted className={"wc"} />
                            </Flex>

                            <div className="row col-12"
                                style={{
                                    marginRight: 0,
                                    marginLeft: 0,
                                }}
                            >
                                {this.state.productos.map((prd, key) => {
                                    return (
                                        <Fragment key={`details-fields-prd-${key}`}>
                                            <Hidden mdUp>
                                                <div
                                                    className={`${this.state.numeroCamposDetalle > 6 ? "col-12 col-lg-6 col-md-12 col-sm-12 col-xs-12" : "col-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"}`}
                                                    style={{
                                                        paddingRight: 0,
                                                        paddingLeft: 0,
                                                    }}
                                                >
                                                    <Details
                                                        inf={prd}
                                                        i={key}
                                                    />
                                                </div>
                                            </Hidden>
                                            <Hidden smDown >
                                                <div
                                                    className={`${this.state.numeroCamposDetalle > 6 ? "col-12 col-lg-6 col-md-12 col-sm-12 col-xs-12" : "col-12 col-lg-12 col-md-12 col-sm-12 col-xs-12"}`}
                                                    style={{
                                                        paddingRight: 0,
                                                        paddingLeft: this.state.numeroCamposDetalle <= 6 ? 0 : (this.state.numeroCamposDetalle % 2 === 0 ? this.paddingLeft(key) : this.paddingLeft(key) === 15 ? 15 : 0),
                                                    }}
                                                >
                                                    <Details
                                                        inf={prd}
                                                        i={key}

                                                    />
                                                </div>
                                            </Hidden>
                                        </Fragment>
                                    )

                                })
                                }
                            </div>
                        </div>}
                        <Flex className="col-12 px-lg-4 pt-3 fixed-to-bottom">
                            <div className="col-12 pt-3  px-md-0" >
                                <Btn
                                    loading={this.state.loading}
                                    disabled={this.state.loading}
                                    onClick={() => this.crearFactura()}
                                >Pagar</Btn>
                            </div>
                        </Flex>
                    </div>
                </Mycard>
            </Elastic>
        );
    }
}

export default withRouter(InicioFormulario);
